import Termly from 'termly-namespace'

import { isAutoBlocked } from '../utils/getters'
import { isBlockable } from '../utils/blockingList'


/**
 * @param {Element} node
 * @param {string} [src=node.getAttribute('src')] the value of the `src`
 *   attribute that is about to be set on `node`. This is necessary when
 *   creating an Image object and assigning a URL to its `src` attribute.
 *
 * @returns {boolean} true if the element needs to be blocked, false otherwise
 */
export default function needsBlocking(node, src) {
  if ( Termly.isAutoBlockerPaused() ) {
    return false
  }

  if ( isAutoBlocked(node) ) {
    return false
  }

  const attrSrc = src || node.getAttribute('src')

  // The URL object will resolve relative links for us. We don't want
  // to block resources from our own host.
  const url = new URL(attrSrc, window.location)

  // It's possible that the src attribute has changed after the initial category
  // assignment, but since categories are typically configured on a hostname or
  // domain name basis, a category change would not be necessary unless the
  // hostname changed...which seems exceedingly unlikely. So, rather than
  // complicate the code to handle the cornerest of corner cases, we're just
  // going to leave the categories alone.
  return isBlockable(url, node.dataset.categories)
}
